import { render, staticRenderFns } from "./classes.vue?vue&type=template&id=f752c8d2&"
import script from "./classes.vue?vue&type=script&lang=js&"
export * from "./classes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports